import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../form-components/input/Button';

const VerifyRulingPayment: React.FC = () => {
  const [verificationStatus, setVerificationStatus] = useState<string | null>(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const authToken = sessionStorage.getItem('token');
  const transactionId = queryParams.get('transaction_id');
  console.log(transactionId)
  const navigate = useNavigate();

  useEffect(() => {
    const verifyPayment = async () => {
      if (transactionId) {
        try {
          const response = await fetch('https://backend-kyw8.onrender.com/court-records/payment/verify', {
            method: 'POST',
            headers: {
              "Authorization": `Bearer ${authToken}`,
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ transactionId }),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const result = await response.json();
          const applicationId = result.applicationId
          const caseId = result.caseId
          console.log(applicationId)
          console.log(caseId)
          setVerificationStatus(result.message || 'Verification successful');
          localStorage.setItem('applicationId', applicationId);
          localStorage.setItem('caseId', caseId);
        } catch (error) {
          setVerificationStatus('Error verifying payment');
          console.error('Error verifying payment:', error);
        }
      } else {
        setVerificationStatus('No payment reference found');
      }
    };

    verifyPayment();
  }, [authToken, transactionId]);
  
  return (
    <div className='main-div'>
        <div className='form-div !max-w-fit flex flex-col gap-6 border border-[#222222] rounded-[20px]'>
            <h2 className='text-black font-semibold text-3xl text-center'>
                Payment Verification
            </h2>
            <div>
                <p className='text-[#8b8989] font-normal text-base text-center'>
                    {verificationStatus}
                </p>
                <p className='text-[#8b8989] font-normal text-base text-center'>
                    <Button buttonText='Upload Signature and Digital Seal' isLoading={false} onClick={(e) => navigate('/upload-document')} disabled={!verificationStatus}/>
                </p>
            </div>
        </div>
    </div>
  );
}

export default VerifyRulingPayment;
